import React, { createContext, useContext, useState } from "react";
import {
  useRunVeilleEvenementielle,
  useRunVeilleReglementaire,
  useRunVeilleInformatique,
} from "../hooks/veille";
import type { VeilleTheme } from "../hooks/veille";

export type VeilleMainTab = "evenementielle" | "reglementaire" | "informative";

interface VeilleContextValue {
  activeTab: VeilleMainTab;
  setActiveTab: (tab: VeilleMainTab) => void;
  activeInfoTab: VeilleTheme;
  setActiveInfoTab: (tab: VeilleTheme) => void;
  periodDaysEvenementielle: number;
  setPeriodDaysEvenementielle: (days: number) => void;
  periodDaysReglementaire: number;
  setPeriodDaysReglementaire: (days: number) => void;
  periodDaysInformative: number;
  setPeriodDaysInformative: (days: number) => void;
  evenementielle: ReturnType<typeof useRunVeilleEvenementielle>;
  reglementaire: ReturnType<typeof useRunVeilleReglementaire>;
  informatique: ReturnType<typeof useRunVeilleInformatique>;
}

const VeilleContext = createContext<VeilleContextValue | null>(null);

export function VeilleProvider({ children }: { children: React.ReactNode }) {
  const [activeTab, setActiveTab] = useState<VeilleMainTab>("evenementielle");
  const [activeInfoTab, setActiveInfoTab] = useState<VeilleTheme>("Eau");
  const [periodDaysEvenementielle, setPeriodDaysEvenementielle] = useState(30);
  const [periodDaysReglementaire, setPeriodDaysReglementaire] = useState(30);
  const [periodDaysInformative, setPeriodDaysInformative] = useState(30);

  const evenementielle = useRunVeilleEvenementielle();
  const reglementaire = useRunVeilleReglementaire();
  const informatique = useRunVeilleInformatique();

  return (
    <VeilleContext.Provider
      value={{
        activeTab,
        setActiveTab,
        activeInfoTab,
        setActiveInfoTab,
        periodDaysEvenementielle,
        setPeriodDaysEvenementielle,
        periodDaysReglementaire,
        setPeriodDaysReglementaire,
        periodDaysInformative,
        setPeriodDaysInformative,
        evenementielle,
        reglementaire,
        informatique,
      }}
    >
      {children}
    </VeilleContext.Provider>
  );
}

export function useVeilleContext() {
  const ctx = useContext(VeilleContext);
  if (!ctx) throw new Error("useVeilleContext must be used within VeilleProvider");
  return ctx;
}
